import React from 'react';

import { SignInTemplate } from '@hero/templates';

import AuthLayout from '../layout';

export default function SignInPage() {
  return (
    <AuthLayout>
      <SignInTemplate />
    </AuthLayout>
  );
}
